import React, { Component } from 'react'
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select'
import 'react-datetime/css/react-datetime.css';
import ls from 'local-storage'

class Partwork extends Component {
    constructor(props){
        super(props);   
        this.state = {
          errors: {},
          tendertypelist: [], 
          partworktypelist: [],
          getpartwork_monitoredbylist: [],
          nature_of_partworklist: [],
          details:[],
          workdetails:[]
      }  
        this.handleChange = this.handleChange.bind(this);  
        this.selecthandleChange = this.selecthandleChange.bind(this);      
      }    
      componentDidMount() {  
        document.title = "Partwork Add/Edit" 
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken; 

        if(this.props.match.params.partworkhead){
          console.log(this.props.match.params.workhead);
          console.log(this.props.match.params.partworkhead);
          console.log(this.props.match.params.officecode);
           Axios.get(`${process.env.REACT_APP_API_URL}partworks/partworkdetail/workhead/`+ this.props.match.params.workhead + `/partworkhead/` + this.props.match.params.partworkhead + `/officecode/` + this.props.match.params.officecode)
         .then(result=>{
           if(result.status === 200){
             this.setState({details:result.data.partworkdetails,workdetails:result.data.workdetail}); 
           }      
         });  
       }     

      Axios.get(`${process.env.REACT_APP_API_URL}master/gettendertype`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.tendertype_id,
              "label" : d.description          
            }))    
            this.setState({tendertypelist: options})  
          }           
        }); 
        Axios.get(`${process.env.REACT_APP_API_URL}master/getpartworktype`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.type_id,
              "label" : d.type_name          
            }))    
            this.setState({partworktypelist: options}) 
          }            
        });   
        Axios.get(`${process.env.REACT_APP_API_URL}master/getpartwork_monitoredby`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.monitored_id,
              "label" : d.monitored_name          
            }))    
            this.setState({getpartwork_monitoredbylist: options}) 
          }            
        });    
        Axios.get(`${process.env.REACT_APP_API_URL}master/getnature_of_partwork`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.nature_id,
              "label" : d.name_of_partwork_nature          
            }))    
            this.setState({nature_of_partworklist: options}) 
          }            
        });                                            
      } 
      handleValidation(){
        let details = this.state.details;        
        let errors = {};
        let formIsValid = true;
        
        //PartWork Name
        if(!details["partworkname"]){
          formIsValid = false;
          errors["partworkname"] = "PartWork Name Cannot be empty";
        }
        
        if(typeof details["partworkname"] !== "undefined"){
          if(!details["partworkname"].match(/^[a-zA-Z0-9_ .-]+$/)){
            formIsValid = false;
            errors["partworkname"] = "Only letters";
          }      	
        } 
       
        //Monitor by
        if(!details["monitorby"]){
          formIsValid = false;
          errors["monitorby"] = "Please Select Monitor by";
        }    
        if(typeof details["monitorby"] !== "undefined"){
          if(typeof details["monitorby"] !== "number"){
            formIsValid = false;
            errors["monitorby"] = "Only Number";
          }      	
        }     
        
        //Tender Type
        if(!details["tendertype"]){
          formIsValid = false;
          errors["tendertype"] = "Please Select Tender Type";
        }    
        if(typeof details["tendertype"] !== "undefined"){
          if(!details["tendertype"].match(/^[A-Z]+$/)){
            formIsValid = false;
            errors["tendertype"] = "Only letters";
          }      	
        }       
        this.setState({errors: errors});
        return formIsValid;
      }
    
      contactSubmit(e){        
        e.preventDefault();
        if(this.handleValidation()){
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const data =  this.state.details;  
          Axios.post(`${process.env.REACT_APP_API_URL}works/workinsert`, data) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Redirect To PartWork List",
                  icon: "success",
                  buttons: true
                })
                .then((responce) => {
                  if (responce) {
                    this.props.history.push({  
                      pathname: '/partworklist'
                    });                   
                  } 
                });                
                
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
            });
        }else{
          swal("Error", "Plese Entry * Fiels", "error");          
        }    
      }    
      async handleChange(event) {
        let details = this.state.details;
        let errors = this.state.errors;
        details[event.target.name] = event.target.value;  
        errors[event.target.name] = '';       
        this.setState({details,errors});       
      }  
      async selecthandleChange(name,e) {
        let details = this.state.details;        
        let errors = this.state.errors;
        details[name] = e.value;   
        errors[name] = '';       
        this.setState({details,errors});        
      } 
      datepickerhandleChange(name,e){
        let details = this.state.details;
        details[name] = e.format('DD-MM-YYYY');
        this.setState({details});
      }           
    render() {  
        return (
                <div className="content-wrapper">
                  <section className="content-header">
                      <h1>
                        Partwork Detail
                        <small>it all starts here</small>
                      </h1>
                      <ol className="breadcrumb">
                        <li><i className="fa fa-dashboard"></i> Home</li>
                        <li>Work List</li>
                        <li className="active">Partwork Detail</li>
                      </ol>
                  </section>
                  <section className="content">
                      <div className="box">
                        <div className="box-body">
                            <form onSubmit= {this.contactSubmit.bind(this)} >
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Partwork Name</label>
                                        <textarea className="form-control" name="partworkname" cols="50" rows="2" onChange={this.handleChange} value={ this.state.details.partworkname || '' } />
                                        <span className="text-red">{this.state.errors["partworkname"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Partwork Name Guj</label>
                                        <textarea className="form-control" name="partworknameguj" cols="50" rows="2" id="partworknameguj" onChange={this.handleChange} value={ this.state.details.partworknameguj  || ''} />								
                                    </div>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Tender Type</label>
                                        <Select 
                                        options={this.state.tendertypelist} 
                                        value={this.state.tendertypelist.filter(({value}) => value === this.state.details.tendertype) || ''}                                        
                                        name="tendertype" 
                                        onChange={this.selecthandleChange.bind(this,'tendertype')} 
                                        />                                      
                                        <span className="text-red">{this.state.errors["tendertype"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                <div className="form-group">
                                                <label>No. of Habitations Covered</label>
                                                <input className="form-control" type="text" name="habitation" value={this.state.details.habitation  || '' } onChange={this.handleChange} />
                                            </div>						
                                        </div>	
                                        </div>
                                        <div className="col-md-12">	
                                        <div className="col-md-6">
                                <div className="form-group">
                                                <label>No. of Villages Covered</label>
                                        <input className="form-control" type="text" name="village" value={this.state.details.village  || '' } onChange={this.handleChange} />
                                            </div>						
                                        </div>	
                                        <div className="col-md-6">
                                <div className="form-group">
                                                <label>No. of Cities/Towns Covered</label>
                                        <input className="form-control" type="text" name="city"value={this.state.details.city  || '' } onChange={this.handleChange} />
                                            </div>						
                                        </div>                                  
                                        </div>  
                                 <div className="col-md-12">                                
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Partwork Type</label>	
                                        <Select 
                                        options={this.state.partworktypelist} 
                                        name="partworktype" 
                                        value={this.state.partworktypelist.filter(({value}) => value === this.state.details.partworktype) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'partworktype')} 
                                        />
                                        <span className="text-red">{this.state.errors["partworktype"]}</span>					
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">To Be Monitored BY</label>
                                        <Select 
                                        options={this.state.getpartwork_monitoredbylist} 
                                        name="monitorby" 
                                        value={this.state.getpartwork_monitoredbylist.filter(({value}) => value === this.state.details.monitorby) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'monitorby')} 
                                        />
                                        <span className="text-red">{this.state.errors["monitorby"]}</span>
                                    </div>
                                  </div>                                  
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Nature of Work</label>
                                        <Select 
                                        options={this.state.nature_of_partworklist} 
                                        name="natureofpartwork" 
                                        value={this.state.nature_of_partworklist.filter(({value}) => value === this.state.details.natureofpartwork) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'natureofpartwork')} 
                                        />
                                        <span className="text-red">{this.state.errors["natureofpartwork"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Remark Gujarati</label>
                                        <textarea className="form-control" name="remarkguj" cols="50" rows="2" onChange={this.handleChange} value={this.state.details.remarkguj || ''} /> 
                                    </div>
                                  </div>                                  
                              </div>
                              <div className="box-footer">
                                  <button type="submit" className="btn btn-primary" name="Update">Save</button>
                              </div>
                            </form>
                        </div>
                      </div>
                  </section>
                </div>           
        )
    }
}
export default Partwork